import { map } from 'rxjs/operators';

import type { AddressFormKit, AddressKitInfo } from 'v2/interfaces/addressKit';

import apiService from './api';

import type { ApiService } from './api';

class KitService {
  constructor(private apiService: ApiService) {}

  public async getBeltKitInfo(): Promise<AddressKitInfo> {
    return this.apiService
      .get('/kits/notification')
      .pipe(map((response) => response.data))
      .toPromise();
  }

  public saveNewAddressToKit(payload: AddressFormKit) {
    return this.apiService.post('/kits/notification/address', payload).toPromise();
  }

  public getCitiesByState(state: string) {
    return this.apiService
      .get(`/kits/states/${state}/cities`)
      .pipe(map((response) => response.data))
      .toPromise();
  }
}

const kitService = new KitService(apiService);
export default kitService;
